import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import SectionHeadline from 'shared/components/SectionHeadline';
import { Switch } from 'shared/components/form/Inputs';
import { colors } from 'shared/defaultTheme';

const SaveDocumentsConfig = ({ mainColor, saveDocsComunications, setSaveDocsComunications }) => {
  const { t } = useTranslation();
  const onChangeSaveDocumentsConfig = () => {
    setSaveDocsComunications(!saveDocsComunications);
  };
  return (
    <>
      <SectionHeadline
        className="general-customizer__section-headline-2"
        sectionNumber={6}
        label={t('general_config_save_documents')}
        color={mainColor}
      />
      <div className="general-customizer__save-documents_wrapper">
        <Switch
          className="text-uppercase"
          id="switchConfigSaveDocuments"
          label={t('general_config_save_documents_button')}
          color={saveDocsComunications ? mainColor : colors.pattens}
          textColor={mainColor}
          value={!saveDocsComunications}
          onChange={onChangeSaveDocumentsConfig}
        />
      </div>
    </>
  );
};

SaveDocumentsConfig.propTypes = {
  mainColor: PropTypes.string.isRequired,
  saveDocsComunications: PropTypes.bool.isRequired,
  setSaveDocsComunications: PropTypes.func.isRequired,
};

export default SaveDocumentsConfig;
